import * as React from "react"
import { ViewStyle } from "react-native"
import { observer } from "mobx-react-lite"
import { IModalProps, Modal, View } from "native-base"
import { JalaWebView } from "../jala-web-view/jala-web-view"
import { useMemo, useRef } from "react"
import WebView from "react-native-webview"
import { RootStoreProvider, useStores } from "../../models"

const WEB_VIEW: ViewStyle = {
  flexGrow: 1,
}

export interface SamplingCameraWebViewModalProps extends IModalProps {
  onSetData?: (data: any) => void
}

/**
 * Describe your component here
 */
export const SamplingCameraWebViewModal = observer(function SamplingCameraWebViewModal(props: SamplingCameraWebViewModalProps) {
  const {
    isOpen,
    onSetData,
    ...restProps
  } = props
  const rootStore = useStores()
  const webView = useRef<WebView>()

  const source = useMemo(() => {
    return { uri: 'https://jala-app-widgets-next.vercel.app/sampling' }
  }, [])

  return <Modal
    testID="jala:id/sampling-camera-modal"
    isOpen={isOpen}
    {...restProps}
  >
    <RootStoreProvider value={rootStore}>
      <View
        alignSelf="stretch"
        flex={1}
        marginY="0px"
        marginX="0px"
        backgroundColor="white"
      >
        <JalaWebView
          ref={webView}
          source={source}
          style={WEB_VIEW}
          startInLoadingState
          onSetData={onSetData}
          cacheEnabled
        />
      </View>
    </RootStoreProvider>
  </Modal>
})
